<template>
  <v-card :loading="loading" :disabled="loading">
    <v-card-title v-html="messageObject.title ? messageObject.title : defaultTitle"></v-card-title>
    <v-card-text>
      <v-row v-if="showInput">
        <v-col cols="12">
          <v-form ref="frmInput" v-model="valid" lazy-validation class="form-inputs">
            <TextField outlined :label="inputLable" :placeholder="inputLable" v-model="inputValue" :rules="[rules.required]"></TextField>
          </v-form>
        </v-col>
      </v-row>
      <div v-html="messageObject.text"></div>
    </v-card-text>
    <v-card-actions>
      <v-btn :color="isDarkTheme ? 'secondary' : 'primary'" @click="confirm"> <v-icon>mdi-check</v-icon> Ok </v-btn>
      <v-spacer></v-spacer>
      <v-btn class="secondary" @click="cancel"> <v-icon>mdi-cancel</v-icon> Cancel </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import TextField from "./Fields/TextField.vue";
export default defineComponent({
  components: { TextField },
  props: {
    message: {
      type: Object as () => { title: string; text: string },
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showInput: {
      type: Boolean,
      default: false,
      required: false,
    },
    inputLable: {
      type: String,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      defaultTitle: "Process Confirmation",
      inputValue: null,
      rules: {
        required: (value: any) => (!(value instanceof Array) && !!value) || (value instanceof Array && value.length > 0) || "Required.",
      },
      valid: true,
      messageObject: "",
    };
  },
  methods: {
    confirm(): void {
      if ((this as any).showInput == true) {
        const isValid = (this.$refs.frmInput as any).validate();
        if (isValid) {
          this.$emit("confirm", (this as any).inputValue);
        }
      } else {
        this.$emit("confirm");
      }
    },
    cancel(): void {
      this.$emit("cancel");
    },
  },
  watch: {
    message: {
      handler: function (newValue) {
        (this as any).messageObject = newValue;
      },
      immediate: true,
    },
  },
  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.current.dark;
    },
  },
});
</script>
